import React from "react";
import PackageSelectionCard from "components/Cards/PackageSelectionCard";

function PackageSelectList({ packages, packagesLoading, subscription, subscriptionErrors = {}, onChange }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>
        Pilih Paket
      </div>

      {packagesLoading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 32 }}>
          <div className="lms-spinner" />
        </div>
      ) : (
        <div style={{ maxHeight: "calc(100vh - 340px)", overflowY: "auto", paddingRight: 4 }}>
          {packages.map((pkg) => (
            <PackageSelectionCard
              key={pkg.id}
              package={pkg}
              isSelected={subscription.packageId === pkg.id}
              onSelect={() => onChange("packageId", pkg.id)}
              discountPercent={subscription.discountPercent}
            />
          ))}

          {/* Custom Package */}
          <PackageSelectionCard
            package={{ id: null, name: "Custom Package", price: subscription.customPackagePrice, benefits: [] }}
            isSelected={subscription.packageId === null}
            onSelect={() => onChange("packageId", null)}
            isCustom
            discountPercent={subscription.discountPercent}
          />

          {/* Custom package form */}
          {subscription.packageId === null && (
            <div style={{ background: "var(--slate-50)", border: "1px solid var(--border-subtle)", borderRadius: 12, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 12, marginTop: -6, marginBottom: 10 }}>
              <div className={`lms-form-group ${subscriptionErrors.customPackageName ? "has-error" : ""}`} style={{ marginBottom: 0 }}>
                <label className="lms-label">Package Name</label>
                <input
                  className="lms-input"
                  value={subscription.customPackageName}
                  onChange={(e) => onChange("customPackageName", e.target.value)}
                  placeholder="Masukkan nama paket"
                />
                {subscriptionErrors.customPackageName && <div className="lms-error-msg">{subscriptionErrors.customPackageName}</div>}
              </div>
              <div className={`lms-form-group ${subscriptionErrors.customPackagePrice ? "has-error" : ""}`} style={{ marginBottom: 0 }}>
                <label className="lms-label">Package Price (Rp)</label>
                <input
                  className="lms-input"
                  type="number"
                  min={0}
                  value={subscription.customPackagePrice}
                  onChange={(e) => onChange("customPackagePrice", parseInt(e.target.value) || 0)}
                  placeholder="0"
                />
                {subscriptionErrors.customPackagePrice && <div className="lms-error-msg">{subscriptionErrors.customPackagePrice}</div>}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default PackageSelectList;
